<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="2000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Change Password</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row dense justify="center">
                    <v-col cols="12" sm="5" md="5">
                        <b>Username</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                        <!-- <v-text-field class="mb-0" v-model="username" outlined dense hint="Enter username"
                            prepend-icon="mdi-account-child-circle"></v-text-field> -->
                        <v-autocomplete color="#0F2027" rounded required v-model="username"  :items="all_users" item-text="username" label="Select Username" outlined persistent-hint dense prepend-icon="mdi-account-child-circle" />
                        <!-- <v-combobox color="#0F2027" v-model="username" rounded :items="all_users" label="Select Username" item-text="username" outlined dense prepend-icon="mdi-account-child-circle"></v-combobox> -->
                    </v-col>
                </v-row>
                <v-row dense justify="center" v-if="username" style="margin-top: -10px">
                    <v-checkbox v-model="autoGenerated" color="green" text-color="white" class="checkbox-label"
                        @change="handleCheckboxChange"></v-checkbox><span class="mt-5" style="font-weight:bold">Auto
                        Generate Password ?</span>
                </v-row>
                <v-row dense justify="center">
                    <v-col cols="12" sm="5" md="5" v-if="username">
                        <b>New Password</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                        <v-text-field outlined dense rounded color="#0F2027" v-model="newPassword"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                            name="input-10-1" hint="Enter new password" prepend-icon="lock"
                            @click:append="show1 = !show1"></v-text-field>
                    </v-col>
                </v-row>


                <v-row justify="center">
                    <v-btn class="mt-3" color="info" :disabled="isallowed == false ? true : false" v-if="username"
                        @click="saveData()">
                        Save New Password
                    </v-btn>
                    <v-btn class="mt-3 ml-5" color="info" append-icon :disabled="isallowed == false ? true : false"
                        v-if="username" :loading="loader_for_comm" @click="communicatePassword()">
                        Communicate Existing Password <v-icon color="white" dark right>mdi-gmail</v-icon>
                    </v-btn>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            username: null,
            // extraBreadcrumbItems: [
            

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            userid: null,
            show1: false,
            newPassword: null,
            cnfPassword: null,
            autoGenerated: false,
            loader_for_comm: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            all_users:[],isallowed:false
        }),

        methods: {


           

handleCheckboxChange() {
    if (this.autoGenerated) {
      this.getcreateRandomPassword();
    }
  },
  getcreateRandomPassword() {
    const formData = {
                       
                        flag: this.autoGenerated,
                    };
    axios
      .post("/RoleManagement/createRandomPassword",formData)
      .then((res) => {
        if (res.data.flag == "YES") {
          this.newPassword = res.data.generatednewpassword;
            this.showSnackbar("#4caf50", "Create Random Password succesfully..!");
        } else {
          this.showSnackbar("#b71c1c", res.data.snackbar);
        }
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
        console.error(error);
      });
  },





            saveData() {
                if (this.username == null || this.username == "") {
                    this.showSnackbar("#b71c1c", "Please enter username...!");
                    return false;
                } else if (this.newPassword == null || this.newPassword == "") {
                    this.showSnackbar("#b71c1c", "Please enter new password...!");
                    return false;
                } else {
                    const formData = {
                        username: this.username,
                        password: this.newPassword,
                    };
                    const change = confirm("Are you sure you want to change the password...!!!");
                    if (change) {
                        axios
                            .post("/RoleManagement/changeAdminPassword", formData)
                            .then((res) => {
                                if (res.data.flag == "YES") {
                                    this.newPassword = '';
                                    this.showSnackbar("#4caf50", res.data.snackbar);
                                } else {
                                    this.showSnackbar("#b71c1c", res.data.snackbar);
                                }
                            })
                            .catch((error) => {
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                                window.console.log(error);
                            });
                    }
                }
            },
            communicatePassword() {
                this.loader_for_comm = true;
                const formData ={
                    username: this.username,
                }
                
                axios
                .post("/RoleManagement/communicatePassword",formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", res.data.snackbar);
                        this.loader_for_comm = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.loader_for_comm = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    console.error(error);
                });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
          axios
            .post("/Admin/getAllUser")
            .then((res) => {
                 if (res.data.flag == "No") {
                    this.isallowed=res.data.isallowed
                this.showSnackbar("red",res.data.snackbar)
                 this.load = false;
                }else{
                this.all_users = res.data.all_users
                this.load = true;
                 this.isallowed=res.data.isallowed
                }
              })
            .catch((error) => {
              window.console.log(error);
            });
        },
    };
</script>

<style></style>
